import React from 'react'
import { goToStripe } from '../payments/stripeOnboarding'
import AuthLayout, { AuthLogo } from './AuthLayout'

// StripeContinue is where Stripe sends her when its form's link has expired
// or was already used (the API's refresh URL): it asks for a fresh link and
// goes straight back. If Stripe can't be reached she can try again, or go back
// to her Card payments card.
export default function StripeContinue({ onDone }: { onDone: () => void }) {
  const [failed, setFailed] = React.useState(false)

  const go = React.useCallback(() => {
    setFailed(false)
    goToStripe().catch(() => setFailed(true))
  }, [])

  // Once per visit: a second link (StrictMode runs effects twice) would only
  // be thrown away.
  const started = React.useRef(false)
  React.useEffect(() => {
    if (started.current) return
    started.current = true
    go()
  }, [go])

  return (
    <AuthLayout>
      <div className="auth-form" aria-live="polite">
        <AuthLogo />
        <div className="auth-branding">
          {failed ? (
            <>
              <h1>Couldn’t open Stripe</h1>
              <p className="auth-subtitle">Check your connection, then try again. Your progress with Stripe is saved.</p>
            </>
          ) : (
            <h1>Taking you back to Stripe…</h1>
          )}
        </div>
        {failed && (
          <>
            <button type="button" className="btn btn-primary" onClick={go}>
              Try again
            </button>
            <button type="button" className="btn btn-quiet" onClick={onDone}>
              Back to Harmovi
            </button>
          </>
        )}
      </div>
    </AuthLayout>
  )
}
